export const DEFAULT_STATE = {
  last: null,
  lastRunning: null,
  lastPerformed: null,
  lastSuccessful: null,
  lastComplete: null,
  lastErrored: null,
  lastCanceled: null,
  lastIncomplete: null,
  performCount: 0,
};

Object.freeze(DEFAULT_STATE);
